// extracted by mini-css-extract-plugin
export default {"folderNameInput":"CreateFolder_folderNameInput__XgjRV","folderNameLabel":"CreateFolder_folderNameLabel__MfCS6"};